import React from 'react';
import { motion } from 'framer-motion';
export function ProductIntro() {
  return <section className="w-full bg-white px-5 py-12 sm:py-20" data-id="element-153" data-mp="22l5dz2tolmka">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.3
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-154" data-mp="22jc31bc1cg6h">
        <span className="mb-5 inline-block rounded-full border border-yellow bg-yellow/20 px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-navy" data-id="element-155" data-mp="2ge4oeqelwqkz">
          Everything inside the lab
        </span>
        <h2 className="font-serif-display text-3xl font-bold leading-tight text-navy sm:text-5xl" data-id="element-156" data-mp="26mh2t64qe3rf">
          Everything they need to think, build, test, and invent.
        </h2>
        <div className="mx-auto mt-6 h-px w-16 bg-blue/40" data-id="element-157" data-mp="2zamnxtzp5urs" />
        <p className="mt-6 text-sm leading-relaxed text-navy/75 sm:text-base" data-id="element-158" data-mp="342e9tr7wrcbl">
          The Young Inventor Lab™ is a ready-to-print build library that removes the hardest part:
          figuring out what to do next. Every card gives kids a clear starting point—and a reason to
          keep exploring.
        </p>
      </motion.div>
    </section>;
}